import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import Keycloak from 'keycloak-js';
import { catchError, throwError } from 'rxjs';

export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
    const keycloak = inject(Keycloak);

    return next(req).pipe(
        catchError((error) => {
            if (error.status === 401) {
                keycloak.logout();
            }
            return throwError(() => error);
        })
    );
};
